<template>
  <van-overlay v-if="showPop" ref="orderPay" :show="showOrderPay" class="order-pay">
    <div class="discount-content" @click.stop>
      <div class="t-c discount-title">应支付
        <div class="discount-close flex flex-m flex-c" @click="closeOrderPay">
          <van-image
            :width="pxTovw(52)"
            :height="pxTovw(52)"
            :src="iconClose"
          />
        </div>

      </div>
      <div class="discount-bottom-content">
        <div v-if="totalAmount !==null " class="discount-name single-line">￥{{ totalAmount.toFixed(2) }}</div>
        <div class="order-pay-left-time">剩余时间 {{ orderInfo.leftTime }}</div>
      </div>

      <div class="order-pay-type-title">请选择支付方式</div>

      <div v-for="(item,index) in payTypeList" :key="index" class="flex flex-m discount-item-content" @click="onChosePayType(item,index)">
        <van-image
          :width="pxTovw(40)"
          :height="pxTovw(40)"
          :src="item.payTypeIcon"
        />
        <div class="discount-item-content-desc">{{ item.payTypeName }}</div>
        <van-image
          v-if="item.isChosed"
          :width="pxTovw(38)"
          :height="pxTovw(38)"
          :src="payChosed"
          class="order-checkbox"
        />
        <van-image
          v-else
          :width="pxTovw(38)"
          :height="pxTovw(38)"
          :src="payUnChosed"
          class="order-checkbox"
        />
      </div>
      <div class="dash-line mt40"/>
      <div class="btn-content flex flex-m">
        <van-button :disabled="payDisabled" class="btn-pay" round type="info" @click="immediatelyPay">立即支付</van-button>
      </div>

    </div>
  </van-overlay>
</template>

<script>
import { Image as VanImage, Overlay, Toast, Popup, Button, Dialog } from 'vant';
import { toPay, getPayTypeList, toWechatPay } from '../../api/order/index';
import { getAlipayData } from '@/api/order/index';

export default {
  components: {
    [VanImage.name]: VanImage,
    [Overlay.name]: Overlay,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [Button.name]: Button
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => {
      }
    },
    orderNo: {
      type: String,
      default: ''
    },
    campusId: {
      type: Number,
      default: null
    },
    totalAmount: {
      type: Number,
      default: null
    },
    showOrderPay: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPop: false,
      payTypeGroup: [
        {
          payTypeIcon: require('../../assets/img/order/icon-alipay.png'),
          payTypeName: '支付宝支付',
          payType: '1',
          isChosed: false
        },
        {
          payTypeIcon: require('../../assets/img/order/icon-wepay.png'),
          payTypeName: '微信支付',
          payType: '2',
          isChosed: false
        },
        {
          payTypeIcon: require('../../assets/img/order/icon-wepay.png'),
          payTypeName: '微信支付',
          payType: '4',
          isChosed: false
        },
        {
          payTypeIcon: require('../../assets/img/order/icon-allpay.png'),
          payTypeName: '聚合支付',
          payType: '3',
          isChosed: false
        }
      ],
      payTypeList: [],
      payType: '3',
      payDisabled: true,
      payChosed: require('../../assets/img/order/icon-checkbox-chosed.png'),
      payUnChosed: require('../../assets/img/order/icon-checkoubox-unchosed.png'),
      iconClose: require('../../assets/img/course/icon-school-close.png')
    };
  },
  watch: {
    async showOrderPay(val) {
      if (val) {
        if (this.campusId) {
          await this.getPayTypeList(this.campusId);
          if (this.payTypeList.length === 0) {
            this.showPop = false;
            this.$emit('close-order-pay', true);
            Toast('支付功能暂未开放！');
          } else {
            this.showPop = true;
          }
        }
      }
    }
  },
  // mounted() {
  //   let isPageHide = false;
  //   window.addEventListener('pageshow', function() {
  //     if (isPageHide) {
  //       window.location.reload(); // 刷新页面
  //     }
  //   });
  //   window.addEventListener('pagehide', function() {
  //     isPageHide = true;
  //   });
  // },
  methods: {
    closeOrderPay() {
      Dialog.confirm({
        message: '支付还未完成，确认退出吗？',
        confirmButtonText: '继续支付',
        confirmButtonColor: '#0F47C1',
        cancelButtonText: '确认退出',
        cancelButtonColor: 'rgba(0, 0, 0, 0.45)'
      })
        .then(() => {
          // on confirm
          this.$emit('continue-pay', true);
        })
        .catch(() => {
          // on cancel

          this.$emit('close-order-pay', false);
        });
    },
    // 获取支付方式
    async getPayTypeList(campusId) {
      await getPayTypeList(campusId).then((result) => {
        console.log('result', result);
        this.payTypeList = [];
        if (Array.isArray(result.data)) {
          let ua = window.navigator.userAgent.toLowerCase();
          console.log('ua', ua);
          result.data.forEach(element => {
            this.payTypeGroup.forEach(ele => {
              if (element === ele.payType && element !== '3') {
                if (/AlipayClient/.test(window.navigator.userAgent)) {
                  // 判断是否是支付宝浏览器打开
                  console.log('支付宝客户端');
                  if (ele.payType === '1') {
                    this.payTypeList.push(ele);
                  }
                } else if (ua.indexOf('micromessenger') > -1) {
                  console.log('微信浏览器');
                  console.log('ele.payType', ele.payType);
                  if (ele.payType === '4') {
                    this.payTypeList.push(ele);
                  }
                } else {
                  this.payTypeList.push(ele);
                }
              }
            });
          });
        }
        console.log('this.payTypeList', this.payTypeList);
      }).catch((err) => {
        console.log('err', err);
      });
    },
    // ready(callback) {
    // // 如果jsbridge已经注入则直接调用
    //   if (window.AlipayJSBridge) {
    //     callback && callback();
    //   } else {
    //   // 如果没有注入则监听注入的事件
    //     document.addEventListener('AlipayJSBridgeReady', callback, false);
    //   }
    // },
    async immediatelyPay() {
      let campusCode = this.$route.query.code;
      if (this.payType === '3') {
        console.log('orderId:', this.orderInfo.orderId.toString());
        sessionStorage.setItem('orderDetailNo', this.orderInfo.orderNo);
        sessionStorage.setItem('hasGoPay', true);
        sessionStorage.setItem('payOrderNo', this.orderInfo.orderNo);
        sessionStorage.setItem('isReceipt', this.orderInfo.isReceipt ? 1 : 0);
        toPay(this.orderInfo.orderId.toString());
      } else if (this.payType === '4') {
        sessionStorage.setItem('orderDetailNo', this.orderInfo.orderNo);
        sessionStorage.setItem('hasGoPay', true);
        sessionStorage.setItem('payOrderNo', this.orderInfo.orderNo);
        sessionStorage.setItem('isReceipt', this.orderInfo.isReceipt ? 1 : 0);
        toWechatPay(this.orderInfo.orderId.toString(), campusCode, this.orderInfo.isReceipt);
      } else if (this.payType === '1') {
        // 如果在支付宝环境 唤起支付宝
        // if (/AlipayClient/.test(window.navigator.userAgent)) {
        sessionStorage.setItem('orderDetailNo', this.orderInfo.orderNo);
        sessionStorage.setItem('hasGoPay', true);
        sessionStorage.setItem('payOrderNo', this.orderInfo.orderNo);
        sessionStorage.setItem('isReceipt', this.orderInfo.isReceipt ? 1 : 0);
        let data = {
          tradeNo: this.orderInfo.orderNo || this.orderNo,
          payType: '1',
          campusCode: this.$route.query.code || ''
        };
        await getAlipayData(data).then(res => {
          if (res.code === 200) {
            if (document.forms.length > 0) {
              let prevDivForm = document.querySelector('divform');
              prevDivForm.remove();
            }
            const div = document.createElement('divform');
            div.innerHTML = res.data.aliWapPay; // data就是接口返回的form 表单字符串
            document.body.appendChild(div);
            // document.forms[0].setAttribute('target', '_blank');
            document.forms[0].submit();

            // if (/AlipayClient/.test(window.navigator.userAgent)) {
            //   // 如果在支付宝环境 唤起支付宝
            //   // 如果在浏览器环境唤起 则提交form表单
            //   // 后面发现 支付宝的浏览器中 也可以使用form表单，会自动检测 不需要用到alipay jsbridge
            //   // this.ready();
            //   // let b = res.data.aliWapPay.substring(res.data.aliWapPay.indexOf('http'));
            //   // let cStr = b.substring(0, b.indexOf('">'));
            //   // console.log('cStr', cStr);
            //   // let dStr = cStr.substring(cStr.indexOf('do?') + 3);
            //   // let ee = encodeURI('{&quot;out_trade_no&quot;:&quot;20210817010101004&quot;,&quot;total_amount&quot;:0.01,&quot;subject&quot;:&quot;测试商品&quot;,&quot;product_code&quot;:&quot;QUICK_WAP_WAY&quot;}');
            //   // dStr += '&biz_content=' + ee;
            //   // // dStr = 'app_id=2021003154644581&method=alipay.trade.wap.pay&format=json&charset=UTF-8&sign_type=RSA2&sign=cV4S%2FC08fZTs11OmIyr0Lu82d%2FXtudgr0hGImGqqFJcSRQjygXDGPBPGg%2F6FY2M0GUA2hpJEvLIaC8CEk87fAJTM0YboR7lkFfxez1Yo%2F9eCFsUiMRTP6synQJjlaLqTlRvZBahNJFu8tk3hBVNVcoFsM1gRDQe3ntGx831AVVc%2B4izF8VXR1Ed12BGE853HjfPMVKSNyFzf9MF3sdZj6F2KoH%2BNomnU9oeRfCrsYXofdXwI6d4euI%2FJu0lkWl7T51Zt6XeNxxwjoBCrSWe34jq8saudDtS%2Fx52TQu0QYYrS3Hq0HZH6x8PLhCGKAUf6OeMPJzBeuyF%2Bb8opbGEqKg%3D%3D&timestamp=2022-10-21+13%3A43%3A59&version=1.0&notify_url=http://common.hlestudy.com:18001&biz_content=';
            //   // // dStr = 'app_id=2015052600090779&biz_content=%7B%22timeout_express%22%3A%2230m%22%2C%22product_code%22%3A%22QUICK_MSECURITY_PAY%22%2C%22total_amount%22%3A%220.01%22%2C%22subject%22%3A%221%22%2C%22body%22%3A%22%E6%88%91%E6%98%AF%E6%B5%8B%E8%AF%95%E6%95%B0%E6%8D%AE%22%2C%22out_trade_no%22%3A%22IQJZSRC1YMQB5HU%22%7D&charset=utf-8&format=json&method=alipay.trade.app.pay&notify_url=http%3A%2F%2Fdomain.merchant.com%2Fpayment_notify&sign_type=RSA2&timestamp=2016-08-25%2020%3A26%3A31&version=1.0&sign=cYmuUnKi5QdBsoZEAbMXVMmRWjsuUj%2By48A2DvWAVVBuYkiBj13CFDHu2vZQvmOfkjE0YqCUQE04kqm9Xg3tIX8tPeIGIFtsIyp%2FM45w1ZsDOiduBbduGfRo1XRsvAyVAv2hCrBLLrDI5Vi7uZZ77Lo5J0PpUUWwyQGt0M4cj8g%3D';
            //   // console.log('dStr', dStr);
            //   // window.AlipayJSBridge.call('tradePay', {
            //   //   orderStr: 'timestamp=2022-10-21+14%3A00%3A42&method=alipay.trade.app.pay&app_id=2014073000007292&sign_type=RSA&charset=utf-8&version=1.0&biz_content=%7B%22timeout_express%22%3A%2230m%22%2C%22seller_id%22%3A%222088411964605312%22%2C%22product_code%22%3A%22QUICK_MSECURITY_PAY%22%2C%22total_amount%22%3A0.01%2C%22subject%22%3A1%2C%22body%22%3A%22%E5%95%86%E5%93%81%E4%B8%AD%E6%96%87%E6%8F%8F%E8%BF%B0%E4%BF%A1%E6%81%AF%22%2C%22out_trade_no%22%3A%22ALIPAYTEST2016081622560194853%22%7D&sign=aueDw0PaUqVMvbiButPCmWy8VsNJIgNKRV4tDEz3mSgIpa5ODnZKVCd1GGCtu7hNzxnwLOiku%2BTRJUVM24aHkKWrdyBHECjkUBvrziWiZBESLCyJPwT1YHGnioRUhLvL1MqTTm85urPeqAUUir4UyxyWowHitjkxh3ru6nSLkLU%3D'
            //   //   // orderStr: 'timestamp=2023-12-27%2018%3A00%3A00&charset=UTF8&method=alipay.trade.wap.pay&sign=QPWwxrbEZ0jUqtBOl0C0k4dv4moaEuHIK0u8DD%2Fv2eoX5S%2BncuaQpssmNHhwFIpvGJ4UU5blhsRp8o0MZnXtx3P7ihRb5hrbEPiyaJEagXQdlBEHQXZ5H3Iz4GW9xz4a78htAxejOzFo9MLzXTqFsq%2BJBGUhsQblvGniF9TmRYAMoIwSNEZ1NnbP1wO638BzhBdD04i%2BEyzmxHTbBsRoT88wu5QNZT2b7o9kCkSUSn3Arpo4U%2BJdKUHgR%2F3Z0IVZF%2F1rU9SDnT4HleQ7M7D3sIV4N%2BplMOqovhaLyGPhnUZYEL1d4dl4%2BxEBwPfZ2OND64tiajYarGLuwTyOLR9A8A%3D%3D&version=1.0&app_id=2021000120616343&sign_type=RSA2&timestamp=2022-10-17+17%3A28%3A48&alipay_sdk=alipay-sdk-java-dynamicVersionNo&format=json'
            //   // }, function(result) {
            //   //   alert(JSON.stringify(result));
            //   // });
            // } else {
            //   // 如果在浏览器环境唤起 则提交form表单
            //   const div = document.createElement('divform');
            //   div.innerHTML = res.data.aliWapPay; // data就是接口返回的form 表单字符串
            //   document.body.appendChild(div);
            //   if (isiOS) {
            //     document.forms[0].submit();
            //   } else {
            //     document.forms[0].setAttribute('target', '_blank'); // 新开窗口跳转
            //     document.forms[0].submit();
            //   }
            // }
          } else {
            Toast(res.msg);
          }
        });
        // } else {
        //   // 如果在浏览器环境唤起支付宝 跳转页面 提示 请在支付宝浏览器中打开
        //   Toast('请在支付宝客户端打开链接');
        // }
      }

      this.$emit('true-immediately-pay', this.payType, this.orderInfo.orderNo, this.orderInfo.orderId.toString());
    },
    onChosePayType(item, index) {
      this.payTypeList.forEach((element, idx) => {
        if (index === idx) {
          element.isChosed = true;
          this.payType = element.payType;
        } else {
          element.isChosed = false;
        }
      });
      this.payDisabled = false;
    }
  }
};
</script>

<style scoped lang="scss">
.order-pay {
  text-align: center;

  .discount-content {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #fff;
    border-radius: 24px 24px 0 0;

    .discount-title {
      position: relative;
      height: 112px;
      font-size: 32px;
      font-family: $font-Medium;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.65);
      line-height: 112px;
    }

    .discount-close {
      position: absolute;
      width: 92px;
      height: 100%;
      top: 0;
      right: 0;
    }

    .discount-bottom-content {
      padding-left: 30px;
      padding-right: 30px;

      .discount-name {
        font-size: 60px;
        font-family: $font-Medium;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 84px;
      }

      .order-pay-left-time {
        width: fit-content;
        font-size: 28px;
        font-family: $font-Regular;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 40px;
        margin-top: 20px;
        margin-left: auto;
        margin-right: auto;
      }
    }

    .order-pay-type-title {
      width: fit-content;
      font-size: 28px;
      font-family: $font-Medium;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.65);
      line-height: 40px;
      margin-top: 60px;
      margin-bottom: 20px;
      padding-left: 30px;
      padding-right: 30px;
    }

    .discount-item-content {
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 30px;
      padding-right: 30px;

      &-desc {
        max-width: 600px;
        font-size: 28px;
        font-family: $font-Regular;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 48px;
        margin-left: 16px;
      }

      .order-checkbox {
        margin-right: 0;
        margin-left: auto;
      }
    }

    .btn-content {
      width: 100%;
      height: 126px;
      background: #fefffe;
      padding-left: 30px;
      padding-right: 30px;

      .btn-pay {
        width: 100%;
        height: 76px;
        background: $blue;
        border-radius: 38px;
        font-size: 28px;
        font-family: $font-Regular;
        font-weight: 500;
        color: #fefffe;
        line-height: 76px;
      }
    }
  }
}

.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mt40 {
  margin-top: 40px;
}

.dash-line {
  width: 100%;
  height: 2px;
  background: #e0e0e0;
  opacity: 0.5;
}

.opacity-gray {
  opacity: 0.45;
  color: #000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/order/orderPay.vue